import React from "react";
import PropTypes from "prop-types";
import _str from "shared/util/_str";

import "apps/messenger/components/MainWindow/Toolbar.scss";

const Toolbar = ({
	userid,
	sendDisabled,
	sendMessage,
	text,
}) => {
	const handleSend = () => sendMessage(userid);

	return (
		<div className="messenger-toolbar">
			<div className="messenger-toolbar-spacer" />
			<button className="messenger-toolbar-send" disabled={sendDisabled} onClick={handleSend}>
				{text}
			</button>
		</div>
	);
};

Toolbar.propTypes = {
	userid: PropTypes.string.isRequired,

	sendMessage: PropTypes.func.isRequired,
	sendDisabled: PropTypes.bool.isRequired,
	text: PropTypes.string,
};

Toolbar.defaultProps = {
	text: _str("Send"),
};

export default Toolbar;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/MainWindow/Toolbar.jsx